import Vue from 'vue';
import Router from 'vue-router';
import login from '@/components/login';
import registration from '@/components/registration';
import dashboard from '@/components/dashboard';
import profile from '@/components/updateProfile';
import download from '@/components/downloads';
import videos from '@/components/videos';
import architecture from '@/components/architecture';
import hardwareCalculator from '@/components/hardwareCalculator';
import licence from '@/components/licence';
import verification from '@/components/verification';
import invoice from '@/components/invoice';
import forgetpassword from '@/components/forgetpassword';
import changepassword from '@/components/changepassword';
import confirmation from '@/components/confirmation';
import notification from '@/components/notification';
import support from '@/components/support';
import Session from '@/Session';
import legal from '@/components/legal';
import privacy from '@/components/privacy';
import termsConditions from '@/components/termsConditions';
import users from '@/components/admin/users';
import userHistory from '@/components/admin/userHistory';
import loginHistory from '@/components/admin/loginHistory';
import usageHistory from '@/components/admin/usageHistory';
import sale from '@/components/sale';
import identityCloak from '@/components/identityCloak';
import rollOut from '@/components/admin/rollOut';
import licenseDetail from '@/components/admin/licenseDetail';
import demoLicense from '@/components/demoLicense';
import axisLicense from '@/components/axisLicense';
import licenseConfirmation from '@/components/licenseConfirmation';
import milestonePlugin from '@/components/milestonePlugin';
import peoplecounting from '@/components/peoplecounter';
import facitSupport from '@/components/facitSupport';
import facitDownloads from '@/components/facitDownloads';
import userGuide from '@/components/userGuide';
import faq from '@/components/faq';
import webinar from '@/components/webinar';
import licenceAll from '@/components/licenceAll';
import orderNow from '@/components/orderNow';
import quote from '@/components/quote';
import FacitMilestoneSmartCount from '@/components/FacitMilestoneSmartCount';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/forgetpassword',
      name: 'forgetpassword',
      component: forgetpassword,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/changepassword',
      name: 'changepassword',
      component: changepassword,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/termsConditions',
      name: 'termsConditions',
      component: termsConditions,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/demoLicense',
      name: 'demoLicense',
      component: demoLicense,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/axisLicense',
      name: 'axisLicense',
      component: axisLicense,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/registration',
      name: 'registration',
      component: registration,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/confirmation',
      name: 'confirmation',
      component: confirmation,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/licenseConfirmation',
      name: 'licenseConfirmation',
      component: licenseConfirmation,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/milestonePlugin',
      name: 'milestonePlugin',
      component: milestonePlugin,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/peoplecounting',
      name: 'peoplecounting',
      component: peoplecounting,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/FacitMilestoneSmartCount',
      name: 'FacitMilestoneSmartCount',
      component: FacitMilestoneSmartCount,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/legal',
      name: 'legal',
      component: legal,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: privacy,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/notification',
      name: 'notification',
      component: notification,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/',
      name: 'dashboard',
      component: dashboard,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: profile,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/downloads',
      name: 'download',
      component: download,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/sale',
      name: 'sale',
      component: sale,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/identityCloak',
      name: 'identityCloak',
      component: identityCloak,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/videos',
      name: 'videos',
      component: videos,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/architecture',
      name: 'architecture',
      component: architecture,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/hardwareCalculator',
      name: 'hardwareCalculator',
      component: hardwareCalculator,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/licence',
      name: 'licence',
      component: licence,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/licenceAll',
      name: 'licenceAll',
      component: licenceAll,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/verification',
      name: 'verification',
      component: verification,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/invoice',
      name: 'invoice',
      component: invoice,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/support',
      name: 'support',
      component: support,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/facitSupport',
      name: 'facitSupport',
      component: facitSupport,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/facitDownloads',
      name: 'facitDownloads',
      component: facitDownloads,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/userGuide',
      name: 'userGuide',
      component: userGuide,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/faq',
      name: 'faq',
      component: faq,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/orderNow',
      name: 'orderNow',
      component: orderNow,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/quote',
      name: 'quote',
      component: quote,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/webinar',
      name: 'webinar',
      component: webinar,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/admin/users',
      name: 'users',
      component: users,
      meta: {
        accessType: 'admin',
      },
    },
    {
      path: '/admin/userHistory',
      name: 'userHistory',
      component: userHistory,
      meta: {
        accessType: 'admin',
      },
    },
    {
      path: '/admin/loginHistory',
      name: 'loginHistory',
      component: loginHistory,
      meta: {
        accessType: 'admin',
      },
    },
    {
      path: '/admin/usageHistory',
      name: 'usageHistory',
      component: usageHistory,
      meta: {
        accessType: 'admin',
      },
    },
    {
      path: '/admin/rollOut',
      name: 'rollOut',
      component: rollOut,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/admin/licenseDetail',
      name: 'licenseDetail',
      component: licenseDetail,
      meta: {
        accessType: 'private',
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (!to.matched.length) return next('/notfound');
  const accessType = to.meta.accessType;
  const pageName = to.name

  if (accessType === 'admin') {
    if (Session.getAccessToken() && Session.getAccessToken().user.role === 'admin') {
      return next();
    }
    return next({
      name: 'login',
      path: '/login',
      query: {
        redirect: to.fullPath,
      },
    });
  }
  if (accessType === 'private') {
    if (Session.getAccessToken()) {
      return next();
    }
    return next({
      name: 'login',
      path: '/login',
      query: {
        redirect: to.fullPath,
      },
    });
  }
  if (accessType === 'public') {
    if (!Session.getAccessToken()) {
      return next();
    } else {
      if (Session.getAccessToken() && (pageName === 'peoplecounting' || pageName === 'userGuide' || pageName === 'facitDownloads'
          || pageName === 'faq' || pageName === 'facitSupport' || pageName === 'orderNow' || pageName === 'quote' || pageName === 'milestonePlugin'
          || pageName === 'FacitMilestoneSmartCount')) {
        return next();
      }
    }
    return next({
      name: 'dashboard',
      path: '/',
    });
  }
  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js